import React from 'react'
import PropTypes from 'prop-types'
import { colors, fontSize } from '@offerzen/pinata'
import CheckCircleIcon from '@offerzen/zenicon/CheckCircleIcon'

import AccessibleIcon from '@/CandidateExperience/components/AccessibleIcon'

import { matchLabel } from '../constants'

import styles from './styles'

const MatchingList = ({ matchingRequirements }) => {
  const numberOfMatchingRequirements = matchingRequirements.length
  const shouldRenderAnd = numberOfMatchingRequirements > 1
  const positionOfAnd = numberOfMatchingRequirements - 1
  const lastPositionOfComma = numberOfMatchingRequirements - 2

  return (
    <div className={styles.matchingListWrapper}>
      <AccessibleIcon icon={CheckCircleIcon} color={colors.cornflowerBlue} className={styles.listMarker} size={fontSize.large} />
      <ul className={styles.commaList}>
        <For each="matchingRequirement" of={matchingRequirements} index="index">
          <li key={matchingRequirement}>
            <If condition={shouldRenderAnd && index === positionOfAnd}> and </If>
            {matchLabel[matchingRequirement]}
            <If condition={index < lastPositionOfComma}>, </If>
          </li>
        </For>
      </ul>
    </div>
  )
}

MatchingList.propTypes = {
  matchingRequirements: PropTypes.arrayOf(PropTypes.string),
}

export default MatchingList
